import React, { useState } from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

import styled from 'styled-components'

import News from '../../sections/News'
import TwoColumns from '../../sections/TwoColumns'
import RestaurantsList from '../../sections/RestaurantsList'


import SEO from '../../components/SEO'
import Hero from '../../components/Hero'
import Button from '../../components/Button'
import ContentBox from '../../components/ContentBox'
import FormBook from '../../components/FormBook'
import Paragraph from '../../components/Paragraph'
import TextHeader from '../../components/TextHeader'
import BackImageSlider from '../../components/BackImageSlider'
import Popup from '../../components/Popup'

import box6image from '../../assets/images/box6.webp'
import box8image from '../../assets/images/box8.webp'
import theRooftop from '../../assets/images/terraces/therooftop_02.webp'
import leDeck from '../../assets/images/terraces/ledeck_01.webp'
import portico from '../../assets/images/terraces/portico_01.webp'
import eventsCover from '../../assets/images/events/cover.webp'
import enricoPromo from '../../assets/images/fiamma-campania.webp'

import popUpImage from '../../assets/images/festive/2023/festive.jpg'

const IndexPage = ({ data }) => {

  const [valentinesPopup, setValentinesPopup] = useState(true)

  const kewy = [
    //{ seo_keyword: 'https://www.sandshospitality.com/' },
    { seo_keyword: 'catering hong kong' }, 
    { seo_keyword: 'catering service hong kong' }, 
    { seo_keyword: 'hong kong hospitality' }, 
    { seo_keyword: 'catering services' }, 
    { seo_keyword: 'restaurant group hong kong' }
  ];

  const Content = styled.div`
    padding: 45px 15px;
    max-width: 1080px;
    position: relative;
    z-index: 10;
  `

  const List = styled.ul`
    margin-top: 15px;
    li {
      padding: 10px 5px;
    }
  `

  const KnowMore = styled.div`
    transform: translateY(-65px) translateX(50px);
    a {
      font-size: 1.5rem;
      color: #a98e67;
      border-bottom: 1px solid #a98e67;
      display: block;
      width: 50%;
      padding: 5px 0px;
      transition: all 500ms;
      &:hover {
        color: #FFF;
        border-bottom: 1px solid #FFF;
      }
    }
  `

  return (
    <>
      <SEO 
        title="Restaurant Group Hong Kong | S&S Hospitality" 
        keywords={kewy}
        canonical="https://www.sandshospitality.com/"
        home={true}
      />
      <Hero
        heroImages={data.allStrapiHeroImages.edges}
        bottomContainer={<FormBook data={data.allStrapiRestaurants.edges} />}
      />
      {/* <Popup
        active={valentinesPopup === true}
        handleClose={() => setValentinesPopup(false)}
        bgColor="none"
      >
        <a href="/festive-season" target='_blank' referrerPolicy='noreferrer'>
          <img src={popUpImage} alt="Festive Season" style={{ maxWidth: 960, width: '100%' }} />
        </a>
      </Popup> */}
      <RestaurantsList restaurantsList={data.allStrapiRestaurants.edges} />
      <News newsList={data.allStrapiPromotions.edges.map(item => item.node)} />
      <TwoColumns>
        <ContentBox image={eventsCover} color="darkSecond" />
        <ContentBox color="darkSecond" center middle>
          <TextHeader>Events & Catering Services in Hong Kong</TextHeader>
          <Paragraph center>
            Looking for the perfect venue for your next big event? Our restaurants, bars and terraces provide spectacular catering services for any event in Hong Kong.
          </Paragraph>
          <AniLink cover direction="down" bg="#171717" to="/events">
            <Button>Read more</Button>
          </AniLink>
        </ContentBox>
      </TwoColumns>
      <TwoColumns reverse>
        <BackImageSlider images={[theRooftop,leDeck,portico]} duration={3} transition={2}></BackImageSlider>
        <ContentBox color="primary" center middle>
          <TextHeader white>Hong Kong's Most Sought-After Terraces</TextHeader>
          <Paragraph center white>
          Showcasing Hong Kong’s most breath-taking views and vistas, S&S Hospitality's spectacular terraces and rooftops are the oases of serenity amidst the bustling city.
          </Paragraph>
          <AniLink cover direction="down" bg="#171717" to="/terraces">
            <Button white>Read more</Button>
          </AniLink>
        </ContentBox>
      </TwoColumns>
      <TwoColumns>
        <ContentBox image={box6image} color="primary" />
        <ContentBox color="darkSecond" center middle>
          <TextHeader>Gift Cards</TextHeader>
          <Paragraph center white>
          Give the gift of incredible culinary experiences! S&S Gift Cards are the finest way of expressing “You Are Special”. With the gift card, you can indulge in any S&S Hospitality restaurant, lounge, terrace and rooftop dining outlets of your choice in Hong Kong. Our Gift Card is the ideal present for any special occasion and any discerning flavour.
          </Paragraph>
          <AniLink cover direction="down" bg="#171717" to="/giftcards">
          <Button>Read More</Button>
          </AniLink>
        </ContentBox>
      </TwoColumns>
      <TwoColumns reverse>
        <ContentBox image={box8image} color="darkSecond" />
        <ContentBox color="primary" center middle>
          <TextHeader white style={{ lineHeight: 1.4 }}>The S&S Elite Club <br /> It’s a Gem of an Experience!</TextHeader>
          <Paragraph center white>
          Hong Kong’s premier hospitality group is pleased to present the exclusive S&S Elite Club membership, bringing you a world of privilege with indulgence. Sink your teeth into world-class cuisines and magnificent entertainment by being a member of the Elite Club.
          </Paragraph>
          <AniLink cover direction="down" bg="#171717" to="/loyalty">
          <Button white>Read More</Button>
          </AniLink>
        </ContentBox>
      </TwoColumns>
      <Content>

        <span itemscope itemtype="https://schema.org/FAQPage">
        <h2 style={{ fontSize: '35px', lineHeight: 3 }}>Hong Kong Restaurant FAQs</h2>

<span itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
<h2 style={{ fontSize: '30px', lineHeight: 2 }} itemprop="name">What sort of catering and events services do you offer in Hong Kong?</h2>
<span itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
<span itemprop="text">
<Paragraph>As a premier <strong>hospitality</strong> and <strong>restaurant group in Hong Kong</strong> are committed to providing bespoke <a href="/catering-services">catering and event services</a> designed to cater to all of your needs. We are here to make sure that your entire event embodies your precise vision - from start to finish. Our service includes not only the cuisine, but the decor, special effects, <a href="/portfolio/boticario">live music</a>, and overall ambience to curate a remarkable and memorable catering experience.</Paragraph>
<Paragraph>For <a href="/catering-services">catering</a>, you can choose from a wide selection of international cuisine from our premier portfolio of <strong>restaurants in Hong Kong</strong>, with our staff offering heartfelt services to ensure your event runs smoothly and stress-free. Learn more about our events and <a href="/catering-services">catering services in Hong Kong</a>.</Paragraph>
</span>
</span>
</span>

<span itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
<h2 style={{ fontSize: '30px', lineHeight: 2 }} itemprop="name">What dining outlets are included in your Hong Kong restaurant group?</h2>
<span itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
<span itemprop="text">
<Paragraph>Our <strong>group&rsquo;s restaurants</strong> are as diverse as they are delicious. We pride ourselves in creating, developing, and constantly innovating our <strong>Hong Kong restaurants</strong> to lift any occasion with scrumptious delicacies and spoil your palate. No matter if you crave the exotic flavours of Indian cuisine, wish to be transported to the Mediterranean Coast, or feel like you are on the lamp-lit streets of Paris - our restaurants are at your service to bring in a journey around the world with <a href="/catering-services">catering services</a> you will adore.</Paragraph>
</span>
</span>
</span>

<span itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
<h2 style={{ fontSize: '30px', lineHeight: 2 }} itemprop="name">Our Restaurant Group in Hong Kong</h2>
<span itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
<span itemprop="text">
<List>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/alto">Alto Bar &amp; Grill</AniLink></li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/bombay-dreams">Bombay Dreams</AniLink></li>
<li>Bombay Dreams To-go</li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/boticario">Boticario Bar &amp; Grill</AniLink></li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/bouchon-bistro">Bouchon Bistro Francais</AniLink></li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/braza">Braza Churrascaria Brazilian Steakhouse</AniLink></li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/dragonfly">Dragonfly</AniLink></li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/fiamma">FIAMMA</AniLink></li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/harbourside-grill">Harbourside Grill</AniLink></li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/tango">TANGO</AniLink></li>
<li><AniLink cover direction="down" bg="#171717" to="/portfolio/spiga">SPIGA</AniLink></li>
</List>
</span>
</span>
</span>

</span>
      </Content> 
    </>  
    
  )
}

export default IndexPage